import { useEffect } from "react";

const SITE_URL = "https://ca.spiritiitg.in";
const DEFAULT_IMAGE = `${SITE_URL}/sl.png?v=2`;
const LD_JSON_ID = "seo-structured-data";

function upsertMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-page SEO tags. `path` should start with "/" (e.g. paths.about).
 * Pages that require auth should pass noindex to keep them out of Google.
 * Pass `structuredData` (a plain object) to emit a JSON-LD <script> tag.
 */
const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
  structuredData = null,
}) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    upsertLink("canonical", url);

    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "Spirit CA Portal");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", image);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    let script = document.getElementById(LD_JSON_ID);
    if (structuredData) {
      if (!script) {
        script = document.createElement("script");
        script.id = LD_JSON_ID;
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(structuredData);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, noindex, structuredData]);

  return null;
};

export default Seo;
